import packageInfo from '../../package.json';

export const environment = {
  production: true,
  apiUrl: 'https://www.filingssummary.com/api',
  v: packageInfo.version,
  timezone: 'America/New_York'
};
